import { WinterIcon, SummerIcon } from '@assets/icons';

const SESSION_TYPES = {
  YAZ: 'Summer',
  KIS: 'Winter',
};

export const getSessionIcon = (type: string) => {
  switch (type) {
    case SESSION_TYPES.YAZ:
      return SummerIcon;
    case SESSION_TYPES.KIS:
      return WinterIcon;

    default:
      return undefined;
  }
};
